import DeleteGenericModal from "../../modals/DeleteGenericModal";
import ReactTable from "../../util/ReactTable";
import AsyncBlock from "../../components/forms/AsyncBlock";
import PageTitle from "../../components/layout/PageTitle";
import PageSection from "../../components/layout/PageSection";
import Button from "../../components/forms/Button";
import PageContainerFull from "../../components/layout/PageContainerFull";
import {useCallback, useMemo} from "react";
import {FlexLayout} from "../../components/flex/Flex";
import useDeleteModal from "../../modals/useDeleteModal";
import axios from "axios";
import useFetch2 from "../../hooks/useFetch2";
import {Apis} from "../../util/data";
import {useNavigate} from "react-router-dom";
import {format} from "date-fns";
import {AiOutlinePlus} from "react-icons/ai";
import * as React from "react";
import {FaEdit, FaFileUpload, FaTrash} from "react-icons/fa";
import useModal from "../../modals/useModal";
import ExcelReader from "../../components/ExcelReader";
import GenericModal2 from "../../modals/GenericModal2";
import {Dropdown} from "react-bootstrap";
import {HiOutlineEllipsisVertical} from "react-icons/hi2";
import {FaFilePdf} from "react-icons/fa6";
import {RiVirusFill} from "react-icons/ri";
import {CiPill} from "react-icons/ci";
import {MdLocalHospital} from "react-icons/md";

const RiskList = () => {

  const navigate = useNavigate()
  const {loading, data, fetchData, error} = useFetch2(Apis.PROD + '/riesgo/list', []);

  const deleteElement = id => axios.delete(Apis.PROD + '/riesgo/' + id)

  const formatoFecha = 'dd/MM/yyyy HH:mm:ss';

  const {
    wrapper: wrapper1,
    openDeleteModal
  } = useDeleteModal({
    text: '¿Desea eliminar este riesgo?',
    action: deleteElement,
    onRefresh: fetchData
  })

  function addRisk() {
    navigate('/riesgos/new')
  }

  function editRisk(item) {
    navigate('/riesgos/edit/' + item.id)
  }

  function pdfList(id) {
    navigate('/riesgos/'+id+'/pdfs')
  }

  function enfermedades(id){
    navigate('/riesgos/'+id+'/ponderacion')
  }

  function consejerias(id){
    navigate('/riesgos/'+id+'/consejerias')
  }

  function productos(id){
    navigate('/riesgos/'+id+'/productos')
  }

  const fechaValue = useCallback(cell => {
    const fechaUTC = new Date(cell.renderValue() + new Date().getTimezoneOffset() * 60000);
    return format(fechaUTC, formatoFecha)
  }, []);
  const actionsValue = useCallback(cell =>
    <Dropdown>
      <Dropdown.Toggle variant="light" id="dropdown-custom-1" size='sm'>
        <HiOutlineEllipsisVertical size={16} />
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Item onClick={() => editRisk(cell.row.original)}>
          <FaEdit /> <span>Editar</span>
        </Dropdown.Item>
        <Dropdown.Item onClick={() =>  openDeleteModal(cell.row.original.id)}>
          <FaTrash /> <span>Eliminar</span>
        </Dropdown.Item>
        <Dropdown.Item onClick={() => pdfList(cell.row.original.id)}>
          <FaFilePdf /> <span>Pdf</span>
        </Dropdown.Item>
        <Dropdown.Item onClick={() => enfermedades(cell.row.original.id)}>
          <RiVirusFill /> <span>Enfermedades</span>
        </Dropdown.Item>
        <Dropdown.Item onClick={() => productos(cell.row.original.id)}>
          <CiPill/> <span>Productos</span>
        </Dropdown.Item>
        <Dropdown.Item onClick={() => consejerias(cell.row.original.id)}>
          <MdLocalHospital/> <span>Consejerias</span>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
    // eslint-disable-next-line react-hooks/exhaustive-deps
    , []);

  const columns = useMemo(
    () => [
      {
        header: 'Riesgo',
        accessorKey: 'riesgo'
      },
      {
        header: 'Grupo',
        accessorKey: 'grupo',
      },
      {
        header: 'Valor si',
        accessorKey: 'valorSi',
        meta: {
          headerClassName: 'text-center', // class para la cabecera
          columnClassName: 'text-center', // class para la columna
        }
      },
      {
        header: 'Ajuste edad',
        accessorKey: 'ajusteEdad',
        meta: {
          headerClassName: 'text-center', // class para la cabecera
          columnClassName: 'text-center', // class para la columna
        }
      },
      {
        header: 'Actualizacion',
        accessorKey: 'actualizacion',
        cell: fechaValue
      },
      {
        header: 'Acciones',
        accessorKey: 'id',
        meta: {
          headerClassName: 'text-center', // class para la cabecera
          columnClassName: 'text-center', // class para la columna
        },
        enableSorting: false, // para deshabilitar el sort
        cell: actionsValue
      }
    ]
    // eslint-disable-next-line react-hooks/exhaustive-deps
    , [data]
  )



  const {wrapper: wrapper2, someAction: openExcelReader} = useModal({
    component: <ExcelReader/>
  })

  return (
    <PageContainerFull>

      <PageSection>
        <PageTitle title={'Riesgos'}/>

        <AsyncBlock loading={loading} error={error}>
          <ReactTable
            columns={columns}
            data={data || []}
            customSearch
            customButton={
            <Button variant='light' onClick={openExcelReader}>
              <FaFileUpload />
              <span>Subir</span>
            </Button>}
            filterAdd={() => addRisk()}
            noData='No existen riesgos'
            pageSize={20}
          />
        </AsyncBlock>
      </PageSection>
      <DeleteGenericModal {...wrapper1} />
      <GenericModal2 {...wrapper2}/>
    </PageContainerFull>
  )
}

export default RiskList
